"use client";

export default function ErrorBoundary({ reset }: { error: Error; reset: () => void }) {
  return (
    <main style={{ font: "16px/1.5 Satoshi, system-ui, sans-serif", maxWidth: "32rem", margin: "15vh auto", padding: "0 1.5rem" }}>
      <h1>This page is temporarily unavailable</h1>
      <p>Please try again in a moment.</p>
      <button type="button" onClick={reset}>Try again</button>
    </main>
  );
}
